import { useState } from "react";
import { Link, useSearchParams } from "react-router";
import { FileText } from "lucide-react";
import { competenciaAtual } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { usePermissao } from "@/lib/use-permissao";
import { AFaturar } from "@/components/financeiro/extratos/AFaturar";
import { ExtratosEmitidos } from "@/components/financeiro/extratos/ExtratosEmitidos";
import { AReceberPorMes } from "@/components/financeiro/a-receber/AReceberPorMes";
import { AtalhosDaCobranca } from "./AtalhosDaCobranca";
import { FecharEEnviarDialog } from "./FecharEEnviarDialog";

type Lista = "faturar" | "extratos";

/** Financeiro › Cobranças: com os extratos ligados, os atalhos, o que falta faturar, os extratos
 *  emitidos e o que é de antes deles, por mês; sem eles, o a receber por mês de sempre. */
export function AbaDeCobrancas({ competencia, onConfigurar }: { competencia: string; onConfigurar: () => void }) {
  const config = trpc.financeiro.configExtrato.ler.useQuery().data;
  const podeMexer = usePermissao("finance.manage");
  const [params, setParams] = useSearchParams();
  const [fechando, setFechando] = useState(false);
  const lista: Lista = params.get("ver") === "extratos" ? "extratos" : "faturar";
  const ver = (chave: Lista) =>
    setParams((p) => {
      p.set("ver", chave);
      return p;
    }, { replace: true });
  if (!config) return null;

  if (!config.ativo) {
    return (
      <div className="space-y-4">
        <div className="flex flex-wrap items-center gap-3 rounded-xl border border-brand-100 bg-brand-50/60 px-4 py-3 dark:border-primary/20 dark:bg-primary/5">
          <FileText className="h-5 w-5 shrink-0 text-brand-600 dark:text-primary" />
          <p className="min-w-0 flex-1 text-sm text-zinc-700 dark:text-foreground">
            Cobre com <b>extrato</b>: numerado, com a sua marca e as formas de pagamento, por clínica ou por dentista, na frequência de cada cliente, enviado por e-mail.
          </p>
          <Link to="/financeiro?aba=configuracoes" className="text-sm font-semibold text-brand-700 hover:underline dark:text-primary">
            Ligar os extratos
          </Link>
        </div>
        <AReceberPorMes competencia={competencia} />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <AtalhosDaCobranca lista={lista} onFechar={podeMexer ? () => setFechando(true) : null} onIr={(a) => (a === "configuracoes" ? onConfigurar() : ver(a))} />
      {lista === "faturar" ? <AFaturar /> : <ExtratosEmitidos />}
      {/* Sem seletor de mês aqui: o que é de antes dos extratos aparece todo, até o mês atual. */}
      <AReceberPorMes competencia={competenciaAtual()} legado />
      <FecharEEnviarDialog aberto={fechando} onFechar={() => setFechando(false)} />
    </div>
  );
}
